<app-standard-bottom-sheet [isOpen]="isOpen()"
                           (isOpenChange)="isOpen.set($event)"
                           [title]="'BQ' + bqStep() + ' Sections'"
                           testId="checklist-sections-sheet">
  <div class="sections-list"
       role="listbox"
       aria-label="Checklist sections"
       data-testid="checklist-sections-sheet-list">
    @for (section of sections(); track section.id) {
      <button type="button"
              class="section-option"
              (click)="onSelectSection(section.id)"
              data-testid="checklist-sections-sheet-option">
        <span class="section-option-name">
          <span class="answer-icon answer-icon-check answer-icon-pass"
                [class.hide]="isSectionComplete(section) === false"
                aria-hidden="true"></span>
          {{ section.name }}
        </span>
        <span class="section-option-progress"
              data-testid="checklist-sections-sheet-progress">{{ section.answeredCount }}/{{ section.totalCount }}</span>
      </button>
    }
  </div>
</app-standard-bottom-sheet>